import { Redirect, useLocalSearchParams } from "expo-router";

export default function CatchAllRedirect() {
  const { catchAll, ...rest } = useLocalSearchParams<{ catchAll: string[] }>();
  const currentPath = Array.isArray(catchAll) ? catchAll.join("/") : "";

  // Новый путь с сохранением query-параметров
  const newPath = `/orgs/${currentPath}`;

  return (
    <Redirect
      href={{
        pathname: `/orgs/${currentPath}` as any,
        params: rest, // Передаёт все query-параметры
      }}
    />
  );
}
